import { useEffect, useState } from "react";
import styles from "../styles/OrderScreen.module.css";
import Layout from "../components/Layout";
// import { logger } from "../utils/logger";
// const log = logger.child({ module: "totoro" });

export default function OrderScreen({ onLogout }) {
  const [orders, setOrders] = useState([]);
  const [isModalOpen, setModalOpen] = useState(false);
  const [couriers, setCouriers] = useState([]);
  const [selectedCourier, setSelectedCourier] = useState(null);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  

    // Добавьте эту функцию в компонент OrderScreen
const getDeliveryTime = (whenConfirmed, deliveryDuration) => {
  if (!whenConfirmed || !deliveryDuration) return "Не указано";
  
  try {
    const confirmedTime = new Date(whenConfirmed);
    const deliveryTime = new Date(confirmedTime.getTime() + deliveryDuration * 60000);
    
    return deliveryTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  } catch (e) {
    console.error("Ошибка форматирования времени доставки:", e);
    return "Ошибка времени";
  }
};
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const saveCompletedItems = (orderId, items) => {
    const completedItems = JSON.parse(localStorage.getItem('completedItems') || '{}');
    completedItems[orderId] = items.filter(item => item.completed).map(item => item.id);
    localStorage.setItem('completedItems', JSON.stringify(completedItems));
  };

  const getCompletedItems = (orderId) => {
    const completedItems = JSON.parse(localStorage.getItem('completedItems') || '{}');
    return completedItems[orderId] || [];
  };

  const fetchData = async () => {
    setIsLoading(true);
    setErrorMessage(null);

    try {
      let token = localStorage.getItem("token");
      const organizationCode = localStorage.getItem("organizationCode");
      const adminCode = localStorage.getItem("adminCode");

      const headers = {
        "Content-Type": "application/json",
        "X-Organization-Code": organizationCode,
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...(adminCode ? { "X-Admin-Code": adminCode } : {}),
      };

      // log.debug("Fetching orders...");
      const ordersResponse = await fetch("/api/orders", { headers });
      if (!ordersResponse.ok) {
        const error = await ordersResponse.json();
        // log.error("Error fetching orders:", error);
        throw new Error(error.message || "Ошибка загрузки заказов");
      }
      const ordersData = await ordersResponse.json();
      // log.debug("Orders data received:", ordersData);

      if (!Array.isArray(ordersData.dataList)) {
        // log.error("Invalid orders data format:", ordersData);
        throw new Error("Некорректный формат данных заказов");
      }

      if (ordersData.newToken) {
        localStorage.setItem("token", ordersData.newToken);
        token = ordersData.newToken;
      }

      const excludedStatuses = [
        "OnWay",
        "Closed",
        "Waiting",
        "Unconfirmed",
        "Delivered",
        "Cancelled",
        "WaitCooking",
        "ReadyForCooking",
      ];

      setOrders(
        ordersData.dataList
          .filter((order) => {
            const status = order.status || order.order?.status;
            return !excludedStatuses.includes(status);
          })
          .map((order) => {
            const completedItemIds = getCompletedItems(order.id);
            return {
              ...order,
              items: order.items?.map((item) => ({
                ...item,
                completed: completedItemIds.includes(item.id),
              })) || [],
            };
          })
      );

      // log.debug("Fetching couriers...");
      const couriersResponse = await fetch("/api/couriers", { headers });
      if (!couriersResponse.ok) {
        const error = await couriersResponse.json();
        // log.error("Error fetching couriers:", error);
        throw new Error(error.message || "Ошибка загрузки курьеров");
      }
      const couriersData = await couriersResponse.json();
      // log.debug("Couriers data received:", couriersData);

      if (couriersData.newToken) {
        localStorage.setItem("token", couriersData.newToken);
        token = couriersData.newToken;
      }

      setCouriers(
        Array.isArray(couriersData.dataList) ? couriersData.dataList : []
      );
    } catch (error) {
      // log.error("Fetch error:", error);
      setErrorMessage(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    const intervalId = setInterval(fetchData, 25000);
    return () => clearInterval(intervalId);
  }, []);

  const handleItemComplete = (orderId, itemId) => {
    setOrders((prevOrders) => {
      const updatedOrders = prevOrders.map((order) =>
        order.id === orderId
          ? {
              ...order,
              items: order.items.map((item) =>
                item.id === itemId ? { ...item, completed: true } : item
              ),
            }
          : order
      );

      const order = updatedOrders.find((o) => o.id === orderId);
      if (order) {
        saveCompletedItems(orderId, order.items);
      }

      return updatedOrders;
    });
  };

  const isAllItemsCompleted = (order) => {
    return order.items.every((item) => item.completed);
  };

  const handleOpenModal = (orderId) => {
    setSelectedOrderId(orderId);
    setModalOpen(true);
    setErrorMessage(null);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedCourier(null);
    setSelectedOrderId(null);
    setErrorMessage(null);
  };

  const handleSelectCourier = (courierId) => {
    setSelectedCourier(courierId);
    setErrorMessage(null);
  };

  const updateOrderStatus = async (orderId, status, paymentType, courierId = null) => {
    try {
      setIsLoading(true);
      setErrorMessage(null);
      // log.debug(`Updating order status. Order: ${orderId}, Status: ${status}, Payment: ${paymentType}, Courier: ${courierId}`);

      const token = localStorage.getItem("token");
      if (!token) throw new Error("Токен авторизации отсутствует");

      const response = await fetch(`/api/orders/`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          "X-Organization-Code": localStorage.getItem("organizationCode"),
        },
        body: JSON.stringify({
          id: orderId,
          status: status,
          paymentType: paymentType,
          courierId: courierId,
        }),
      });
      
      const result = await response.json();
      // log.debug("Update order response:", result);

      if (!response.ok) {
        throw new Error(result.message || "Ошибка сервера при обновлении статуса заказа");
      }

      if (result.newToken) {
        localStorage.setItem("token", result.newToken);
      }

      const completedItems = JSON.parse(localStorage.getItem('completedItems') || '{}');
      delete completedItems[orderId];
      localStorage.setItem('completedItems', JSON.stringify(completedItems));

      setOrders((prev) => prev.filter((o) => o.id !== orderId));
      return true;
    } catch (error) {
      // log.error("Error updating order status:", error);
      setErrorMessage(error.message || "Произошла ошибка при обновлении статуса заказа");
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  const orderClose = async (orderId) => {

    try {
      setIsLoading(true);
      setErrorMessage(null);
      
      const token = localStorage.getItem("token");
      if (!token) throw new Error("Токен авторизации отсутствует");
      console.log("Запрос на апи " + orderId);

      const response = await fetch(`/api/orders/close`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          "X-Organization-Code": localStorage.getItem("organizationCode"),
        },
        body: JSON.stringify({
          orderId: orderId,
          organizationId: localStorage.getItem("organizationId"),
        }),
      });
      
      const result = await response.json();
      // log.debug("Update order response:", result);

      if (!response.ok) {
        throw new Error(result.message || "Ошибка сервера при обновлении статуса заказа");
      }

      // if (result.newToken) {
      //   localStorage.setItem("token", result.newToken);
      // }

      // const completedItems = JSON.parse(localStorage.getItem('completedItems') || '{}');
      // delete completedItems[orderId];
      // localStorage.setItem('completedItems', JSON.stringify(completedItems));

      setOrders((prev) => prev.filter((o) => o.id !== orderId));
      return true;
    } catch (error) {
      // log.error("Error updating order status:", error);
      setErrorMessage(error.message || "Произошла ошибка при обновлении статуса заказа");
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  const handleAssignCourier = async () => {
    if (!selectedOrderId) return;
    const order = orders.find(o => o.id === selectedOrderId);
    if (!order) return;
    // log.debug(`Assigning courier ${selectedCourier} to order ${selectedOrderId}`);
    const success = await updateOrderStatus(selectedOrderId, "Waiting", order.paymentType, selectedCourier);
    if (success) handleCloseModal();
  };

  const handleOrderAction = async (orderId) => {
    const order = orders.find(o => o.id === orderId);
    if (!order) return;
    // log.debug(`Processing order action for ${orderId}, payment type: ${order.paymentType}`);

    if (order.paymentType === "BOLT") {
      // log.debug("Closing BOLT order without courier assignment");
      console.log("пытаемся вызвать функцию закрытия заказа" + orderId);
      const success = await orderClose(orderId);
      if (success) {
        // setOrders(prev => prev.filter(o => o.id !== orderId));
        console.log("Заказ закрыт успешно" );
      }
      else{
        console.log("Заказ закрыт не успешно" );
      }
    } else {
      handleOpenModal(orderId);
    }
  };

  return (
    <Layout onLogout={onLogout}>
      <div className={styles.order__screen}>
        <h1>Замовлення</h1>
        <main className={styles.main}>
          {orders.length === 0 ? (
            <p>Заказов нет</p>
          ) : (
            orders.map((order) => (
              <div key={order.id} className={styles.card}>
                <div className={styles.card__header}>
                  <h2>{order.customerName}</h2>
                  <div className={styles.order__meta}>
                    <span>№{order.number}</span>
                    <span>{order.paymentType}</span>
                    <span>
                      {`Час доставки: ${getDeliveryTime(order.whenConfirmed, order.deliveryDuration)}`}
                    </span>
                  </div>
                  {order.courierInfo && (
                    <div className={styles.courierInfo}>
                      <span>Кур'єр:</span>
                      <strong>{order.courierInfo.courier?.name || "Не назначен"}</strong>
                      {order.courierInfo.courier?.phone && (
                        <span> ({order.courierInfo.courier.phone})</span>
                      )}
                    </div>
                  )}
                  <div className={styles.order__address}>
                    <p>{order.address}</p>
                  </div>
                  <div className={styles.order__address}>
                    <p>{order.comment || "Коментарий не указан"}</p>
                  </div>
                </div>
                <div className={styles.card__order}>
                  {order.items.map((item) => (
                    <div key={item.id} className={styles.order__item}>
                      <p>
                        {item.name}
                        <span className={styles.item__quantity}> ×{item.amount}</span>
                        {item.comment && (
                          <span className={styles.item__comment}> ({item.comment})</span>
                        )}
                      </p>
                      <button
                        className={styles.order__item__btn}
                        style={{ opacity: item.completed ? 1 : 0.7 }}
                        disabled={item.completed}
                        onClick={() => handleItemComplete(order.id, item.id)}
                      >
                        {item.completed ? "✓ Складено" : "Складено"}
                      </button>
                    </div>
                  ))}
                  <button
                    className={styles.order__btn}
                    style={{
                      opacity: isAllItemsCompleted(order) ? 1 : 0.7,
                      cursor: isAllItemsCompleted(order) ? "pointer" : "not-allowed",
                    }}
                    disabled={!isAllItemsCompleted(order)}
                    onClick={() => handleOrderAction(order.id)}
                  >
                    {order.paymentType === "BOLT" ? "Підтвердити" : "Призначити кур'єра"}
                  </button>
                </div>
              </div>
            ))
          )}
        </main>

        {isModalOpen && (
          <div className={styles.modalBackdrop} onClick={handleCloseModal}>
            <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
              <div className={styles.modalHeader}>
                <h2>Кур'єри</h2>
                <button className={styles.closeBtn} onClick={handleCloseModal}>
                  &#x2715;
                </button>
              </div>

              <div className={styles.modalBody}>
                {errorMessage && (
                  <div className={styles.errorMessage}>{errorMessage}</div>
                )}
                <div className={styles.searchContainer}>
                  <input
                    type="text"
                    placeholder="Пошук кур'єра за ім'ям"
                    value={searchQuery}
                    onChange={handleSearchChange}
                    className={styles.searchInput}
                  />
                </div>

                <div className={styles.couriersList}>
                  {couriers
                    .filter((courier) => courier.isAvailable)
                    .filter((courier) => courier.name.toLowerCase().includes(searchQuery.toLowerCase()))
                    .map((courier) => (
                      <div key={courier.id} className={styles.courierItem}>
                        <span>{courier.name}</span>
                        <button
                          className={styles.order__item__btn}
                          style={{ opacity: selectedCourier === courier.id ? 1 : 0.7 }}
                          onClick={() => handleSelectCourier(courier.id)}
                        >
                          Вибрати
                        </button>
                      </div>
                    ))}
                </div>
              </div>

              <div className={styles.modalFooter}>
                <button
                  className={styles.order__btn}
                  style={{
                    opacity: selectedCourier ? 1 : 0.7,
                    cursor: selectedCourier ? "pointer" : "not-allowed",
                  }}
                  disabled={!selectedCourier || isLoading}
                  onClick={handleAssignCourier}
                >
                  {isLoading ? "Обробка..." : "Призначити"}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
}